// Mehmon kirish ma'lumoti — SOF mantiq, bog'liqliksiz (sabab:
// `branding.ts` boshidagi izoh — `api.ts` ni Node testidan import qilib
// bo'lmaydi, shuning uchun sof qism ajratilgan).
//
// `api.ts` bu yerdagilarni qayta eksport qiladi.
import { cardCredentialFields, type CardCredential } from './voucherCard'

/**
 * Portal tomonidagi kirish ma'lumoti — `venue.api.GuestCredential` (sealed
 * interface, Java record'lar) ning mos keladigan qismi (`SUPPORTED_METHODS`).
 *
 * ⚠️ JSON'da "method"/"type" DISKRIMINATOR MAYDONI YO'Q. `GuestCredential.java`
 * da `@JsonTypeInfo` annotatsiyasi yo'q — Spring Boot 3.4.1 (Jackson 2.18)
 * `sealed interface` + record kombinatsiyasini DEDUCTION orqali, ya'ni JSON
 * ob'ektining MAYDON NOMLARIGA qarab avtomatik farqlaydi. Shuning uchun har
 * bir credential faqat OʻZ record'ining maydonlarini yuboradi — boshqa
 * hech narsa, "usul" yozilmaydi.
 *
 * ⚠️ VOUCHER uchun `identifiedSale` HAR DOIM `false`. Bu maydon "sotuv
 * identifikatsiya bilan qayd etilganmi"ni bildiradi
 * (`docs/09-VENUE-PORTAL.md` §5: anonim karta → INSUFFICIENT, identifikatsiya
 * bilan sotilgan → DELEGATED). Buni FAQAT ob'ekt/sotuv tizimi biladi —
 * anonim mehmon portali bu haqda hech narsa bilmaydi va bila olmaydi. Uni
 * `true` qilib yuborish mehmonning o'zi o'ziga huquqiy kuch berishi
 * bo'lardi, ya'ni №137 talabini soxtalashtirish. Agar zona faqat DELEGATED+
 * kuch talab qilsa va faqat anonim vaucher ruxsat etilgan bo'lsa, backend
 * `InsufficientIdentification` (422) qaytaradi — bu TO'G'RI xatti-harakat,
 * portal buni yashirmaydi.
 */
export type GuestCredentialInput =
  | { method: 'SMS_OTP'; challengeId: string; code: string; phoneE164: string }
  | { method: 'VOUCHER'; card: CardCredential }

export function serializeCredential(credential: GuestCredentialInput): Record<string, unknown> {
  switch (credential.method) {
    case 'SMS_OTP':
      return {
        challengeId: credential.challengeId,
        code: credential.code,
        phoneE164: credential.phoneE164,
      }
    case 'VOUCHER':
      return { ...cardCredentialFields(credential.card), identifiedSale: false }
  }
}

/**
 * Kirish haqiqatan berildimi. `false` — jurnal yozildi, lekin grant hali
 * yo'q (reklama kutilmoqda, `docs/09-VENUE-PORTAL.md` §9.1 javadoc'i).
 *
 * Generik: `api.ts` uni `GuestAccessResult` bilan chaqiradi, lekin funksiya
 * sxemaga bog'liq emas — faqat ikki maydonni ko'radi.
 */
export function hasAccess<T extends { login?: string | null; password?: string | null }>(
  result: T,
): result is T & { login: string; password: string } {
  return result.login !== null && result.password !== null
}
